/* global axios */
import ApiClient from './ApiClient';

class WhatsappTemplatesAPI extends ApiClient {
  constructor() {
    super('whatsapp/templates', { accountScoped: true });
  }

  list(inboxId, status = null) {
    const params = { inbox_id: inboxId };
    if (status) params.status = status;
    return axios.get(this.url, { params });
  }

  create(inboxId, template) {
    return axios.post(this.url, { inbox_id: inboxId, template });
  }

  remove(templateId, templateName, inboxId) {
    return axios.delete(`${this.url}/${templateId}`, {
      params: { inbox_id: inboxId, name: templateName },
    });
  }
}

export default new WhatsappTemplatesAPI();
